<template>
  <div class="form_wrap">
    <vxe-modal
      v-model="uploadConfig.show"
      @hide="hideModel"
      @show="showModel"
      :fullscreen="false"
      :id="uploadConfig.id"
      width="800"
      height="600"
      min-width="600"
      min-height="400"
      show-zoom
      resize
      storage
      show-footer
      :transfer="true"
      :zIndex="1022"
      :destroy-on-close="true"
    >
      <template #title>
        <span>{{uploadConfig.title}}</span>
      </template>
      <template #default>
        <div class="upload">
          <el-upload
            v-if="uploadConfig.type=='edit'"
            class="upload-demo"
            drag
            :action="`/api/common/fileServer/upload`"
            :headers="{'Authorization':'Bearer '+$store.state.user.token}"
            multiple
            :on-success="((res, file)=>{handleFileSuccess(res, file)})"
            :before-upload="(beforeUpload)"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">拖拽或点击上传</div>
          </el-upload>
          <vxe-table
            class="my_table"
            ref="my_table"
            :loading="loading"
            :data="fileList"
            :show-file-list="false"
            border
            show-header-overflow
            highlight-hover-row
            auto-resize
            stripe
            round
            resizable
            header-row-class-name="my_head"
          >
            <vxe-table-column align="center" type="seq" title="序号" width="60" field="index"></vxe-table-column>
            <vxe-table-column align="center" title="文件名" field="name"></vxe-table-column>
            <vxe-table-column align="center" title="预览" width="145">
              <template #default="{ row ,rowIndex }">
                <div class="file_view_wrap">
                  <el-image
                    class="my_pic"
                    v-if="fileType(row.name)=='image'"
                    :src="row.fileUrl"
                    :preview-src-list="[row.fileUrl]"
                  ></el-image>
                  <!-- /DataInput/FileService?type=small&method=DownloadFile&fileid= -->
                  <el-image
                    class="my_pic"
                    v-else-if="fileType(row.name)=='media'"
                    :src="transScaleMedia(row.fileid,'media')"
                  ></el-image>
                  <div class="other_file" v-else>
                    <svg-icon class="svg" :name="`ali_file`" />
                    <div class="other_file_name">{{row.name}}</div>
                  </div>
                  <div
                    @click="showVideo(row)"
                    class="file_video_play"
                    v-if="fileType(row.name)=='media'"
                  >
                    <i class="el-icon-video-play"></i>
                  </div>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="状态"
              field="status"
              v-if="uploadConfig.type=='edit'"
              width="100"
            >
              <template #default="{ row ,rowIndex }">
                <div v-if="row.status=='上传成功'" style="color:green">{{row.status}}</div>
                <div v-else style="color:red">{{row.status}}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column align="center" title="操作" width="145">
              <template #default="{ row ,rowIndex }">
                <div>
                  <el-button
                    v-if="uploadConfig.type=='edit'"
                    size="mini"
                    type="primary"
                    @click="delItem(row,rowIndex)"
                  >删除</el-button>
                  <el-button
                    :disabled="row.status!=='上传成功'"
                    size="mini"
                    type="primary"
                    @click="openFile(row)"
                  >下载</el-button>
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </template>
      <template #footer>
        <vxe-button
          status="primary"
          size="mini"
          @click="uploadConfig.save(d)"
          v-if="uploadConfig.type=='edit'"
        >确认</vxe-button>
        <vxe-button
          status="primary"
          size="mini"
          @click="removeFail"
          v-if="uploadConfig.type=='edit'"
        >清除不成功</vxe-button>
        <vxe-button size="mini" @click="uploadConfig.show=false">取消</vxe-button>
      </template>
    </vxe-modal>
    <common-video-player ref="video" :url="videoUrl" v-if="videoUrl"></common-video-player>
  </div>
</template>

<script>
import { fileType } from "@/util";
import CommonVideoPlayer from "@/components/CommonVideoPlayer";
let Base64 = require("js-base64").Base64;
export default {
  components: {
    CommonVideoPlayer
  },
  props: {
    uploadConfig: {}
  },
  computed: {
    d() {
      var arr = this.fileList.filter(e => e.status == "上传成功");
      return arr.map(e => e.fileUrl).join(",");
    }
  },
  name: "CommonUpload",
  methods: {
    showVideo(row) {
      this.videoUrl=process.env.VUE_APP_BASEURL+'/oss/viewOssFile/'+row.fileid
      this.$nextTick(()=>{
        this.$refs.video.openVideo();
      })
    },
    transScaleMedia(fileid, type) {
      if (type == "image") {
        return (
          process.env.VUE_APP_BASEURL+"/oss/viewOssFile/" +
          fileid +
          "?param=" +
          Base64.encode("x-oss-process=image/resize,m_fill,h_100,w_100")
        );
      }
      if (type == "media") {
        return (
          process.env.VUE_APP_BASEURL+"/oss/viewOssFile/" +
          fileid +
          "?param=" +
          Base64.encode(
            "x-oss-process=video/snapshot,t_50000,f_jpg,w_100,h_100"
          )
        );
      }
    },
    fileType,
    openFile(row) {
      window.open(row.fileUrl);
    },
    delItem(row, rowIndex) {
      if (row.status != "上传成功") {
        this.fileList.splice(rowIndex, 1);
      } else {
        this.$confirm("将删除此条目，是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.fileList.splice(rowIndex, 1);
          })
          .catch(() => {});
      }
    },
    removeFail() {
      this.fileList = this.fileList.filter(e => e.status == "上传成功");
    },
    handleFileChange(file, fileList) {
    },
    beforeUpload(file) {
      this.loading = true;
    },
    handleFileSuccess(res, file) {
      setTimeout(() => {
        this.loading = false;
      }, 500);
      if (res.code==0) {
        this.fileList.push({
          name: file.name,
          status: "上传成功",
          fileid: res.data.fileId,
          fileUrl:res.data.url,
        });
      } else {
        this.fileList.push({
          name: file.name,
          status: res.msg,
          fileid: ""
        });
      }
    },
    handleFileRemove(file, fileList) {
    },
    hideModel() {
      this.fileList = [];
    },
    showModel() {
      if (this.uploadConfig.files) {

        this.fileList = this.uploadConfig.files.split(",").map(e => {
          return {
            name: e,
            status: "上传成功",
            fileid: e,
            fileUrl:e,
          };
        });
      }
    }
  },
  data() {
    return {
      videoUrl: "",
      fileList: [],
      loading: false,
      baseUrl:process.env.VUE_APP_BASEURL,
    };
  },
  created() {}
};
</script>

<style lang="scss">
.el-upload {
    // width: 100%;
    // .el-upload-dragger {
    //     width: 100%;
    // }
}
.my_pic {
    border-radius: 5px;
    padding: 3px;
    box-sizing: border-box;
    border: 2px dashed #cccccc;
}
.el-upload-list {
    display: none;
}
.other_file {
    font-size: 80px;
    .other_file_name {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.file_view_wrap {
    position: relative;
    .file_video_play {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: -5px;
        z-index: 111;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .el-icon-video-play {
            color: #ffffff;
            font-size: 50px;
            opacity: 1;
        }
    }
    .file_video_play:hover {
        .el-icon-video-play {
            opacity: 0.6;
            font-size: 50px;
        }
    }
}
.upload-demo{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  .el-upload{
    width: 100%;
    .el-upload-dragger{
      width: 100%;
    }
  }
}
</style>
